<template>
  <div class="vmodal-wrapper">
    <v-dialog
      v-model="show"
      :width="width || 500"
      :scrollable="scrollable"
      :content-class="overflow ? '' : 'vmodal-overflow-none'"
      @click:outside="show = false"
    >
      <v-card class="v-dialog-card">
        <v-card-title v-if="!hideTitle" class="vmodal-title" primary-title>
          <slot name="title"></slot>
        </v-card-title>

        <div>
          <slot name="body"></slot>
        </div>

        <div>
          <slot name="footer"></slot>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway';

  export default {
    name: 'Vmodal',

    mixins: [clickaway],

    props: {
      dialog: {
        type: Boolean,
        default: false
      },

      width: {
        type: Number,
        default: 500
      },

      scrollable: {
        type: Boolean,
        default: false
      },

      hideTitle: {
        type: Boolean,
        default: false
      },

      overflow: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      show: {
        get() {
          return this.dialog;
        },

        set(value) {
          if (!value) {
            this.$emit('close');
          }
        }
      }
    },

    methods: {
      close() {
        this.show = false;
        this.$emit('close');
      }
    }
  };
</script>

<style lang="scss">
  .vmodal-overflow-none {
    overflow-y: visible !important;
  }

  .vmodal-wrapper {
    * {
      box-sizing: border-box;
    }

    .v-dialog {
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
      border-radius: 2px;
    }
  }

  .v-overlay__scrim {
    background-color: rgb(255, 255, 255) !important;
    border-color: rgb(255, 255, 255) !important;
  }

  .vmodal-wrapper .v-dialog > .v-card > .v-card__title,
  .vmodal-title {
    // // font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 41px;
    letter-spacing: 0.005em;
    color: #233346;
    padding: 0 !important;
    margin-bottom: 30px !important;
  }

  .v-dialog-card {
    padding: 32px 50px 24px 50px;
    height: 100%;
  }

  .v-dialog:not(.v-dialog--fullscreen) {
    max-height: 75% !important;
  }
</style>
